<script>
  import Gua64 from "../utils/Gua64.svelte"
  import XiCu1 from "../books/XiCu1.svelte"
  import XiCu2 from "../books/XiCu2.svelte"
  import ShuoGua from "../books/ShuoGua.svelte"
  import XuGua1 from "../books/XuGua1.svelte"
  import XuGua2 from "../books/XuGua2.svelte"
  import ZaGua from "../books/ZaGua.svelte"
  import WenYan from "../books/WenYan.svelte"
  import { selectedLanguage } from "../etc/store.js"

  let btn_style = "btn waves-effect waves-light light-blue darken-1 btn-single"
  let showDetail = false
  let sectionName = "Books"
  let showYi = false
  let showXicu1 = false
  let showXicu2 = false
  let showShuoGua = false
  let showXugua1 = false
  let showXugua2 = false
  let showZagua = false
  let showWenyan = false

  function showBook(bookId) {
    showDetail = !showDetail

    if (bookId === "guaxusong") {
      showYi = false
      showXicu1 = false
      showXicu2 = false
      showShuoGua = false
      showXugua1 = false
      showXugua2 = false
      showZagua = false
      showWenyan = false
    } else if (bookId === "gua64") {
      showYi = true
      showXicu1 = false
      showXicu2 = false
      showShuoGua = false
      showXugua1 = false
      showXugua2 = false
      showZagua = false
      showWenyan = false
    } else if (bookId === "xicu1") {
      showYi = false
      showXicu1 = true
      showXicu2 = false
      showShuoGua = false
      showXugua1 = false
      showXugua2 = false
      showZagua = false
      showWenyan = false
    } else if (bookId === "xicu2") {
      showYi = false
      showXicu1 = false
      showXicu2 = true
      showShuoGua = false
      showXugua1 = false
      showXugua2 = false
      showZagua = false
      showWenyan = false
    } else if (bookId === "shuogua") {
      showYi = false
      showXicu1 = false
      showXicu2 = false
      showShuoGua = true
      showXugua1 = false
      showXugua2 = false
      showZagua = false
      showWenyan = false
    } else if (bookId === "xugua1") {
      showYi = false
      showXicu1 = false
      showXicu2 = false
      showShuoGua = false
      showXugua1 = true
      showXugua2 = false
      showZagua = false
      showWenyan = false
    } else if (bookId === "xugua2") {
      showYi = false
      showXicu1 = false
      showXicu2 = false
      showShuoGua = false
      showXugua1 = false
      showXugua2 = true
      showZagua = false
      showWenyan = false
    } else if (bookId === "zagua") {
      showYi = false
      showXicu1 = false
      showXicu2 = false
      showShuoGua = false
      showXugua1 = false
      showXugua2 = false
      showZagua = true
      showWenyan = false
    } else if (bookId === "wenyan") {
      showYi = false
      showXicu1 = false
      showXicu2 = false
      showShuoGua = false
      showXugua1 = false
      showXugua2 = false
      showZagua = false
      showWenyan = true
    } else {
      showYi = false
      showXici1 = false
      showXici2 = false
      showShuoGua = false
      showXugua1 = false
      showXugua2 = false
      showZagua = false
      showWenyan = false
    }
  }
</script>

<h3>古籍</h3>
<div class="book-links">
  <button class={btn_style} on:click={() => showBook("gua64")}>周易</button>
  <button class={btn_style} on:click={() => showBook("xicu1")}
    >{$selectedLanguage == "TW" ? "繫辭上" : "系辞上"}</button
  >
  <button class={btn_style} on:click={() => showBook("xicu2")}
    >{$selectedLanguage == "TW" ? "繫辭下" : "系辞下"}</button
  >
  <button class={btn_style} on:click={() => showBook("shuogua")}
    >{$selectedLanguage == "TW" ? "說卦" : "说卦"}</button
  >
  <button class={btn_style} on:click={() => showBook("wenyan")}>文言</button>
  <button class={btn_style} on:click={() => showBook("xugua1")}>序卦上</button>
  <button class={btn_style} on:click={() => showBook("xugua2")}>序卦下</button>
  <button class={btn_style} on:click={() => showBook("zagua")}
    >{$selectedLanguage == "TW" ? "雜卦" : "杂卦"}</button
  >
</div>
<hr />

<div class="card indigo lighten-5">
  <div
    class="card-body note-content"
    style="display:{showYi ? 'block' : 'none'}"
  >
    <Gua64 {sectionName} />
  </div>
</div>
<div class="card indigo lighten-5">
  <div
    class="card-body note-content"
    style="display:{showXicu1 ? 'block' : 'none'}"
  >
    <XiCu1 />
  </div>
</div>
<div class="card indigo lighten-5">
  <div
    class="card-body note-content"
    style="display:{showXicu2 ? 'block' : 'none'}"
  >
    <XiCu2 />
  </div>
</div>
<div class="card indigo lighten-5">
  <div
    class="card-body note-content"
    style="display:{showShuoGua ? 'block' : 'none'}"
  >
    <ShuoGua />
  </div>
</div>
<div class="card indigo lighten-5">
  <div
    class="card-body note-content"
    style="display:{showXugua1 ? 'block' : 'none'}"
  >
    <XuGua1 />
  </div>
</div>
<div class="card indigo lighten-5">
  <div
    class="card-body note-content"
    style="display:{showXugua2 ? 'block' : 'none'}"
  >
    <XuGua2 />
  </div>
</div>
<div class="card indigo lighten-5">
  <div
    class="card-body note-content"
    style="display:{showZagua ? 'block' : 'none'}"
  >
    <ZaGua />
  </div>
</div>
<div class="card indigo lighten-5">
  <div
    class="card-body note-content"
    style="display:{showWenyan ? 'block' : 'none'}"
  >
    <WenYan />
  </div>
</div>

<style>
  .btn-single {
    min-width: 65px;
    height: 40px;
    margin-top: 10px;
    margin-right: 10px;
  }
</style>
